import ReactGA from 'react-ga4';

// GA4 Measurement ID - 실제 ID로 교체 필요
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-XXXXXXXXXX';

export const initGA = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('[GA4] Initialized:', GA_MEASUREMENT_ID);
  } else {
    console.log('[GA4] No measurement ID configured');
  }
};

// 페이지 뷰 트래킹
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// 이벤트 트래킹
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// 사용자 속성 설정
export const setUserProperties = (properties: Record<string, string | number>) => {
  ReactGA.gtag('set', 'user_properties', properties);
};

// 커스텀 이벤트들
export const Analytics = {
  // 인증 관련
  login: (method: string) => {
    trackEvent('Auth', 'login', method);
  },
  signup: (method: string) => {
    trackEvent('Auth', 'signup', method);
  },
  logout: () => {
    trackEvent('Auth', 'logout');
  },

  // 매칭 관련
  joinQueue: (topicId: string, tier: string) => {
    trackEvent('Matching', 'join_queue', `${topicId}_${tier}`);
  },
  matchFound: (topicId: string) => {
    trackEvent('Matching', 'match_found', topicId);
  },
  matchTimeout: () => {
    trackEvent('Matching', 'timeout');
  },

  // 토론 관련
  debateStart: (topicId: string, position: 'pro' | 'con') => {
    trackEvent('Debate', 'start', `${topicId}_${position}`);
  },
  debateEnd: (topicId: string, result: 'win' | 'lose' | 'draw') => {
    trackEvent('Debate', 'end', `${topicId}_${result}`);
  },
  debateLeave: (topicId: string, duration: number) => {
    trackEvent('Debate', 'leave', topicId, duration);
  },

  // 피드백 관련
  feedbackOpen: () => {
    trackEvent('Feedback', 'open');
  },
  feedbackSubmit: (type: string) => {
    trackEvent('Feedback', 'submit', type);
  },

  // 에러 트래킹
  error: (errorType: string, errorMessage: string) => {
    trackEvent('Error', errorType, errorMessage);
  },
};
